import React, { useEffect } from 'react';
import Iframe from 'react-iframe';
import { styled } from '@mui/material/styles';

// Fills the nearest positioned ancestor (InteractiveDocument). Avoids fixed
// `100vh - N` offsets that assumed library tabs chrome.
const Container = styled('div')({
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
});

const iframeClass = 'indoc-iframe';

const IframeStyleHelper = styled('div')({
  position: 'absolute',
  inset: 0,
  [`& .${iframeClass}`]: {
    border: 'none',
    width: '100%',
    height: '100%',
    position: 'absolute',
    inset: 0,
    zIndex: 0,
  },
});

const InDoc = (props) => {
  useEffect(() => {
    const checkChange = () => {
      if (window.innerHeight !== window.screen.height) {
        setTimeout(() => {
          const elem = document.getElementById('indoc_container');
          if (elem) {
            elem.style = '';
          }
        }, 200);
      }
    };

    document.addEventListener('fullscreenchange', checkChange);

    return () => {
      document.removeEventListener('fullscreenchange', checkChange);
    };
  }, []);

  const IframeUrl = props.param ? `${props.url}${props.param}` : `${props.url}`;

  return (
    <Container id="indoc_container">
      <IframeStyleHelper>
        <Iframe url={IframeUrl} id="indoc" className={iframeClass} title="Interactive Document" allowFullScreen />
      </IframeStyleHelper>
    </Container>
  );
};

export default InDoc;
